/** 通用的资源详情信息 **/
import axios from 'axios'
import Utils from '@/core/utils'
import DictSwitch from '@/core/dictSwitch'

const PLACEHOLDER_SORT = {
  PLAN: 1,
  ELEVATION: 2,
  PROFILE: 3,
}
const handleParamsToGroup = (parameters) => {
  const resObj = {}
  parameters.forEach((paramItem) => {
    const groupName = paramItem.groupName
    resObj[groupName] ? resObj[groupName].push(paramItem) : resObj[groupName] = [paramItem]
  })
  const keysArr = Object.keys(resObj)
  return keysArr.reduce((acc, key) => {
    acc.push({
      groupName: key,
      groupProperties: resObj[key]
    })
    return acc
  }, [])
}

const state = {
  currentResource: {
    spaceId: null,
    publicId: null,
    versionId: null,
    softwareCode: null,
    softwareVersion: null,
    language: null,
  },
  // 公共资源详情
  publicResourceInfo: {},
  // 版本资源详情
  versionResourceInfo: {},
  // 版本资源参数类型属性值
  versionParameters: [],
  formatVersionParameters: [],
  // 版本资源文件详情
  versionFileInfo: {},
  // 关联的资源
  relateResource: [],
  // 数据版本信息
  dataVersionInfo: {},
  // gac 3d数据
  geometryData: {},
  showEditBox: false,
}

const getters = {
  currentResource: (state) => state.currentResource,
  publicResourceInfo: (state) => state.publicResourceInfo,
  publicResourceVersions: (state) => { return state.publicResourceInfo.softwareVersions || [] },
  versionResourceInfo: (state) => state.versionResourceInfo,
  // 缩略图
  thumbnails: (state) => {
    let thumbnails = []
    if (state.versionResourceInfo.thumbnails && state.versionResourceInfo.thumbnails.length) {
      const sizes = [...state.versionResourceInfo.thumbnails]
      thumbnails = sizes.sort((t1, t2) =>
        Number(t2.size) - Number(t1.size))[0].thumbnails || []
    }
    return thumbnails.map((url) => `${process.env.VUE_APP_STATIC_HOST}/${url}`)
  },
  // 规格列表
  parameterTypeOptions: (state) => {
    const parameterTypes = state.versionResourceInfo.parameterTypes || []
    return parameterTypes.map((pt) => {
      return pt.name.trim() === '' ? { ...pt, name: '默认' } : pt
    })
  },
  // 所有规格参数
  versionParameters: (state) => state.versionParameters,
  // 版本资源的文件
  versionFileInfo: (state) => state.versionFileInfo,
  // 关联的资源信息
  relateResource: (state) => state.relateResource,
  // 标签
  publicResourceTags: (state) => { return state.publicResourceInfo.tags || [] },
  // gac 3d展示数据
  geometryData: (state) => state.geometryData,
  // 获取gac 3d展示数据时，需要传的参数
  inputParameters: (state) => {
    const inputParams = state.formatVersionParameters.filter((prop) => {
      return prop.guid && (prop.isDriveParameter === 'true' || prop.isOutputParameter === 'true' || prop.isGeometry === 'true')
    })
    return inputParams.map((item) => {
      return { guid: item.guid, value: item.originValue }
    })
  },
  // G构件-规格的几何参数
  parameterGeometryData: (state) => {
    return state.formatVersionParameters.filter((prop) => {
      return prop.isGeometry === 'true'
    }) || []
  },
  // G构件-规格的自定义参数
  parameterCustomData: (state) => {
    return state.formatVersionParameters.filter((prop) => {
      return prop.isCustom === 'true'
    }) || []
  },
  // G构件-规格的标准参数（已处理好分组）
  parameterStandardGroups: (state) => {
    const parameterStandard = state.formatVersionParameters.filter((prop) => {
      return prop.isStandard === 'true'
    }) || []
    return handleParamsToGroup(parameterStandard)
  },
  // R构件-处理规格参数分组
  parameterGroups: (state) => {
    const versionParameters = state.versionParameters
    return handleParamsToGroup(versionParameters)
  },
  // 内建图例
  buildInPlaceholders: (state) => {
    const extendThumbnailMap = state.versionResourceInfo.extendThumbnailMap || {}
    const buildIns = extendThumbnailMap.BUILTIN_PLACEHOLDERS || []
    const ret = []
    buildIns.forEach((item) => {
      const thumbObj = item.thumbnails ? item.thumbnails.find((t) => t.size === '256') : {}
      const obj = {
        isBuildIn: true,
        type: item.type,
        typeCN: DictSwitch.switchPlaceholderType(item.type),
        sort: PLACEHOLDER_SORT[item.type],
        thumbnail: thumbObj.thumbnails[0]
      }
      ret.push(obj)
    })
    return ret.sort((i, j) => i.sort - j.sort)
  },
  // 关联图例
  relatePlaceholders: (state) => {
    const placeholders = state.relateResource.filter((item) => item.resourceType === 'PLACEHOLDER')
    // 固定有4个图例，且排序也固定
    const ret = [
      {
        isBuildIn: false,
        type: 'PLAN',
        typeCN: DictSwitch.switchPlaceholderType('PLAN'),
        major: 'COMMON',
        majorCN: DictSwitch.switchPlaceholderMajor('COMMON'),
      }, {
        isBuildIn: false,
        type: 'PLAN',
        typeCN: DictSwitch.switchPlaceholderType('PLAN'),
        major: 'ELECTRIC',
        majorCN: DictSwitch.switchPlaceholderMajor('ELECTRIC'),
      }, {
        isBuildIn: false,
        type: 'ELEVATION',
        typeCN: DictSwitch.switchPlaceholderType('ELEVATION'),
        major: 'COMMON',
        majorCN: DictSwitch.switchPlaceholderMajor('COMMON'),
      }, {
        isBuildIn: false,
        type: 'PROFILE',
        typeCN: DictSwitch.switchPlaceholderType('PROFILE'),
        major: 'COMMON',
        majorCN: DictSwitch.switchPlaceholderMajor('COMMON'),
      },
    ]
    placeholders.forEach((item) => {
      const typeObj = item.properties.find((ip) => ip.code === 'PLACEHOLDER_VIEW_TYPE') || {}
      const type = typeObj.value
      const majorObj = item.properties.find((ip) => ip.code === 'PLACEHOLDER_DISCIPLINE_TYPE') || {}
      const major = majorObj.value
      const retObj = ret.find((it) => it.type === type && it.major === major)
      const retObjIndex = ret.findIndex((it) => it.type === type && it.major === major)
      ret[retObjIndex] = { ...retObj, ...item }
    })
    return ret
  },
  // 数据版本信息
  dataVersionInfo: (state) => state.dataVersionInfo,
  dataVersionList: (state) => { return state.dataVersionInfo.dataVersions || [] },
  getShowEditBox: (state) => state.showEditBox,
}

const mutations = {
  setInitCurrentResource(state, data) {
    state.currentResource = { ...data }
  },
  setCurrentResource(state, data) {
    state.currentResource = { ...state.currentResource, ...data }
  },
  setPublicResourceInfo(state, data) {
    state.publicResourceInfo = data
  },
  setVersionResourceInfo(state, data) {
    state.versionResourceInfo = data
  },
  setVersionParameters(state, data) {
    state.versionParameters = data
  },
  setFormatVersionParameters(state, data) {
    const resultArr = []
    data.forEach((item) => {
      const parameter = { ...item, originValue: item.value }
      const properties = item.properties
      if (properties && properties.length) {
        properties.forEach((prop) => {
          parameter[prop.code] = prop.value
        })
      }
      if (parameter.isUserVisible === 'true' && parameter.parameterDisplayType !== 'NoDisplay' && parameter.parameterType !== 'ElementId') {
        let value
        if (parameter.value || parameter.value === 0 || parameter.value === false) {
          value = parameter.displayValue || parameter.value
          if (parameter.parameterDisplayType === 'Angle' && !parameter.displayValue) {
            value = Utils.rad2deg(value)
          }
          if (parameter.valueType === 'Number' || parameter.valueType === 'Int') {
            value = Utils.formatValue(value)
            const unit = parameter.displayUnit || parameter.unit
            parameter.value = unit && unit !== 'ul' ? value + unit : value
          } else if (parameter.valueType === 'Enum') {
            parameter.value = parameter.values ? parameter.values[value] : ''
          } else if (parameter.valueType === 'Logic') {
            parameter.value = value.toLowerCase() === 'true' ? '是' : '否'
          } else {
            parameter.value = value
          }
        } else {
          parameter.value = ''
        }
        if (parameter.isGeometry === 'true') {
          parameter.isCustom = 'false'
          parameter.isStandard = 'false'
        } else {
          if (!parameter.groupName) {
            parameter.isCustom = 'true'
            parameter.isStandard = 'false'
          } else {
            parameter.isCustom = 'false'
            parameter.isStandard = 'true'
          }
        }
        resultArr.push(parameter)
      }
    })
    state.formatVersionParameters = resultArr
  },
  setVersionFileInfo(state, data) {
    state.versionFileInfo = data
  },
  setRelateResource(state, data) {
    state.relateResource = data
  },
  setDataVersionInfo(state, data) {
    state.dataVersionInfo = data
  },
  setGeometryData(state, data) {
    state.geometryData = data
  },
  setShowEditBox(state, val) {
    state.showEditBox = val
  },
}

const actions = {
  // 获取公共资源详情
  async loadPublicResourceInfo({ commit }, payload) {
    try {
      const { space_id, space_resource_id } = payload
      const data = await this.$api.resource.getSpaceResourceDetail(space_id, space_resource_id)
      commit('setPublicResourceInfo', data || {})
      commit('setCurrentResource', {
        platform: data.platform || null,
        platformCode: data.platformCode || null,
        language: data.language || null,
      })
    } catch (error) {
      commit('setPublicResourceInfo', {})
      commit('setCurrentResource', {
        platform: null,
        platformCode: null,
        language: null,
      })
    }
  },
  // 获取版本资源详情
  async loadVersionResourceInfo({ commit }, payload) {
    try {
      const { space_id, space_resource_id, resource_software_version_id } = payload
      const data = await this.$api.resource.getSpaceResourceVersionDetail(space_id, space_resource_id, resource_software_version_id)
      commit('setVersionResourceInfo', data || {})
    } catch (error) {
      commit('setVersionResourceInfo', {})
    }
  },
  // 获取版本资源参数类型详情
  async loadVersionResourceParameterInfo({ commit }, payload) {
    try {
      const { space_id, space_resource_id, resource_software_version_id, parameter_type_id } = payload
      const data = await this.$api.resource.getSpaceResourceVersionParameters(space_id, space_resource_id, resource_software_version_id, parameter_type_id)
      commit('setVersionParameters', data || [])
      commit('setFormatVersionParameters', data || [])
    } catch (error) {
      commit('setVersionParameters', [])
    }
  },
  // 获取版本资源文件详情
  async loadVersionResourceFileInfo({ commit }, payload) {
    try {
      const { space_id, space_resource_id, resource_software_version_id } = payload
      const data = await this.$api.resource.getSpaceResourceVersionFile(space_id, space_resource_id, resource_software_version_id)
      commit('setVersionFileInfo', data || {})
    } catch (error) {
      commit('setVersionFileInfo', {})
    }
  },
  // 获取版本资源关联的资源信息
  async loadVersionResourceRelateInfo({ commit }, payload) {
    try {
      const { space_resource_id, resource_software_version_id } = payload
      delete payload.space_resource_id
      delete payload.resource_software_version_id
      const data = await this.$api.resource.detail.relateResourceList(space_resource_id, resource_software_version_id, payload)
      commit('setRelateResource', data || [])
    } catch (error) {
      commit('setRelateResource', [])
    }
  },
  // 获取版本资源的数据版本信息
  async loadVersionResourceDataVersionInfo({ commit }, payload) {
    try {
      const { space_id, space_resource_id, resource_software_version_id } = payload
      const data = await this.$api.resource.getSpaceResourceDataVersions(space_id, space_resource_id, resource_software_version_id)
      commit('setDataVersionInfo', data || {})
    } catch (error) {
      commit('setDataVersionInfo', {})
    }
  },
  // 获取gac的3d数据
  async loadGeometry({ commit }, payload) {
    try {
      const data = await this.$api.threeD.gacDisplayData(payload)
      if (data) {
        // 根据返回的JSON文件地址获取所需的3d展示数据
        const url = `${process.env.VUE_APP_STATIC_HOST}/${data}`
        const resData = await axios.get(url)
        commit('setGeometryData', resData.data || {})
      } else {
        commit('setGeometryData', {})
      }
    } catch (error) {
      commit('setGeometryData', {})
      return Promise.reject(error)
    }
  },
  // 获取RFA的3d数据
  async loadRfaGeometry({ commit }, payload) {
    try {
      // 根据返回的JSON文件所需的3d展示数据
      let data = {}
      try {
        const url = `${process.env.VUE_APP_STATIC_HOST}/metadata/${payload}/display_data.json.gz`
        data = await axios.get(url)
      } catch (error) {
        const url = `${process.env.VUE_APP_STATIC_HOST}/metadata/${payload}/display_data.json`
        data = await axios.get(url)
      }
      if (data) {
        commit('setGeometryData', data.data || {})
      } else {
        commit('setGeometryData', {})
      }
    } catch (error) {
      commit('setGeometryData', {})
      return Promise.reject(error)
    }
  },
  // 获取GAC的3d数据
  async loadGacGeometry({ commit }, payload) {
    try {
      // 根据返回的JSON文件所需的3d展示数据
      const { coreReousrceId, coreReousrceVersionId } = payload
      let data = {}
      try {
        const url = `${process.env.VUE_APP_STATIC_HOST}/metadata/${coreReousrceId}/${coreReousrceVersionId}/display_data.json.gz`
        data = await axios.get(url)
      } catch (error) {
        const url = `${process.env.VUE_APP_STATIC_HOST}/metadata/${coreReousrceId}/${coreReousrceVersionId}/display_data.json`
        data = await axios.get(url)
      }
      if (data) {
        commit('setGeometryData', data.data || {})
      } else {
        commit('setGeometryData', {})
      }
    } catch (error) {
      commit('setGeometryData', {})
      return Promise.reject(error)
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
